import React, {useState} from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import './UpdateAdminiCreate.css';

function UpdateAdminiCreate() {
    const [image , setImage] = useState(null);
    const [name, setName] = useState('');
    const [position , setPosition] = useState('');
    const [acadStanding, setAcadStaing] = useState('');
    const [headOf, setHeadOf] = useState('');
    /*later*/ 
    const navigate = useNavigate();

    

    const Submit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('image', image);
        formData.append('name', name);
        formData.append('position', position);
        formData.append('acadStanding', acadStanding);
        formData.append('headOf', headOf);
    
        try {
            await axios.post('https://school-web-server-eight.vercel.app/createAdmini', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            navigate('/login/updateadministrator');
        } catch (err) {
            console.error('Can\'t create staff:', err);
        }
    };

    const inputImageChange = (e) => {
        console.log("Image change!"+e.target.files[0]); 
        setImage(e.target.files[0])
    }

    return (
        <div className='UpdateAdminiCreate'>
            <div className='form-create-admini'>
                <form onSubmit={Submit}>
                    <h2>Create User</h2>
                    <p>*กรณีที่ไม่มีข้อมูลใดให้เว้นช่องว่างนั้นไว้*</p>
                    <div className='mb-2'>
                        <label htmlFor="">Picture</label>
                        <input type="file" accept='imape/*' className='form-control' 
                        onChange={inputImageChange} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="">ชื่อ-สกุล เช่น นายใจดี มากสุด</label>
                        <input type="text" placeholder='Enter Name' className='form-control'  
                        onChange={(e) => setName(e.target.value)}/>
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="">ตำแหน่ง เช่น ตำแหน่งครู</label>
                        <input type="text" placeholder='Enter Position' className='form-control'  
                        onChange={(e) => setPosition(e.target.value)}/>
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="">วิทยฐานะ เช่น วิทยฐานะครูชำนาญการพิเศษ</label>
                        <input type="text" placeholder='Enter Position' className='form-control'  
                        onChange={(e) => setAcadStaing(e.target.value)}/>
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="">หัวหน้าฝ่าย เช่น หัวหน้าฝ่ายบุคคล</label>
                        <input type="text" placeholder='Enter Position' className='form-control'  
                        onChange={(e) => setHeadOf(e.target.value)}/>
                    </div>
                    {/* <div className='mb-2'>
                        <label htmlFor="">Age</label>
                        <input type="number" placeholder='Enter Email' className='form-control'  
                        onChange={(e) => setAge(e.target.value)}/>
                    </div> */}

                    <button className='btn btn-success'>submit</button>
                </form>
            </div>
        </div>
    )
}


export default UpdateAdminiCreate;